import * as React from 'react';

import { translate } from '~l10n/client';

import { AlertMessage } from '~shared/components/AlertMessage';

export function QuizEditorDeletedMessage() {
  return (
    <div className="py-4">
      <AlertMessage tone="critical" align="center" showIcon>
        {translate('This quiz is deleted.')}
      </AlertMessage>
    </div>
  );
}
